export default {
    common: {
      confirm: '确定',
      cancel: '取消',
      refresh:'刷新缓存',
      editPassword: '修改密码'
    },
    user:{
      username:'用户名',
      account:'账套'
    },
    header: {
      message: '这是公共的头部组件'
    },
    footer: {
      message: '这是公共的底部组件'
    },
    login: {
      login: '登录',
      logout: '退出登录'
    },
    menu:{
      home:'我的首页',
      stock:'库存查询',
      userManage: '用户管理',
      project:'项目列表',
      miniProgram: '小程序',
      merchantsDashboard: '漏斗图',
      merchantsRegistrar: '线索登记',
      businessChances: "商机管理",
      businessChancesDetail: "商机详情",
      merchants: '线索管理',
      merchantSelf: '自主开发',
      publicMerchants: "公共池",
      merchantsGroupName: '客户管理',
      company:'线索来源',
      merchantSources: '线索途径',
      merchantStages: '线索阶段',
      merchantsDetail: "线索详情",
      retention: '留货管理',
      retentionAdd: '留货下单',
      report:'工程报备',
      error:'404',
      authority:'401'
    }
  }